import {FuelType} from "../model/FuelType";
import {BboxResult} from "../model/BboxResult";
import {Station} from "../model/Station";
import {Fuel} from "../model/Fuel";

const BASE_URL = process.env.REACT_APP_STATIONS_API_URL;

export type Bbox = [number, number, number, number];

export interface BboxRequest {
    zoom: number;
    pixelRatio: number;
    bbox: Bbox;
    filters: {
        fuel: FuelType;
        brands: string[];
    };
}

interface FirestoreTimestampSerialized {
    _seconds: number;
    _nanoseconds: number;
}

function toDate(ts: FirestoreTimestampSerialized | Date | undefined | null): Date {
    if (!ts) { return new Date(0); }
    if (ts instanceof Date) { return ts; }
    return new Date(ts._seconds * 1000 + ts._nanoseconds / 1_000_000);
}

function parseFuel(raw: any): Fuel {
    return {
        ...raw,
        lastCachedPriceRefresh: toDate(raw.lastCachedPriceRefresh),
        fiability: {
            ...raw.fiability,
            lastPriceUpdate: toDate(raw.fiability?.lastPriceUpdate),
        },
    } as Fuel;
}

function parseStation(raw: any): Station {
    const fuelCollection: any = {};
    for (const key in raw.fuelCollection ?? {}) {
        const fuel = raw.fuelCollection[key];
        if (fuel?.isDeleted) { continue; }
        fuelCollection[key] = parseFuel(fuel);
    }
    return {
        ...raw,
        fuelCollection,
    } as Station;
}

async function postJson<T>(endpoint: string, body: unknown): Promise<T> {
    if (!BASE_URL) {
        throw new Error("REACT_APP_STATIONS_API_URL is not configured");
    }
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        throw new Error(`${endpoint} failed with HTTP ${response.status}`);
    }
    return response.json() as Promise<T>;
}

export async function getStationsByBbox(request: BboxRequest): Promise<BboxResult[]> {
    return postJson<BboxResult[]>("benzinGetStationByBbox", request);
}

export async function getStationById(id: string): Promise<Station> {
    const raw = await postJson<any>("benzinGetStationById", {id});
    return parseStation(raw);
}
